export const ADDMODAL = 'app/ModalManager/ADDMODAL';
export const POPMODAL = 'app/ModalManager/POPMODAL';
